<script>
// import { required, email } from 'vuelidate/lib/validators'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'EuroCouponsThirdpartyForm',
  components: { DatePicker },
  props: {
    label: {
      type: String,
      required: true,
      default: '',
    },
    value_start: {
      // type: String,
      // required: true,
      default: null,
    },
    value_end: {
      // type: String,
      // required: true,
      default: null,
    },
    is_datetime: {
      // type: String,
      // required: true,
      default: false,
    },
    flag:{
      //type: Boolean,
      //required: false,
      default: false,
    }

  },
  data() {
    return {
      form: {
        payment_due_date: null,
      },

      range: {
          start: null,
          end: null
        },

      masks: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['YYYY-MM-DD'], // Only for `v-date-picker`
        dayPopover: 'L', // Only for `v-date-picker`
        data: ['YYYY-MM-DD'],
      },

      modelConfig: {
        start: {
          type: 'string',
        mask: this.is_datetime ? 'YYYY-MM-DD h:mm A' : 'YYYY-MM-DD', 
        },
        end: {
          type: 'string',
        mask: this.is_datetime ? 'YYYY-MM-DD h:mm A' : 'YYYY-MM-DD', 
        }// Uses 'iso' if missing
      },
    }
  },
  // validations: {
  //   form: {
  //     name: { required, },
  //     nit: { required, },
  //     contact_name: { required, },
  //     contact_email: { required, email },
  //     payment_due_date: { required, },
  //     prefix_code: { required, },
  //     logo: {  },
  //   },
  // },
  computed: {},

  watch: {
    flag(value) {
      this.range['start'] = null
      this.range['end'] = null
      //this.$forceUpdate()
    },
    value_start(value) {
      this.range['start'] = value

    },
    value_end(value) {
      this.range['end'] = value

      

    },
    range: {
      deep: true,
      handler(value) {
        this.$emit('input_start', value.start)
        this.$emit('input_end', value.end)
        if (this.range.start === null && this.range.end == null){
        this.range.start = null
        this.range.end = null
        this.range = null
      }

      },
    },
},

  mounted: function () {


  },

  methods: {},
}
</script>

<template>
  <b-container class="p-0">
    <b-row>
      <b-col md="12">
        <!-- {{range}} -->

        <b-form id="date-picker-range-form">
          <!-- <form-wrapper :validator="$v.form"> -->
            <b-row>
              <b-col md="12">
                <b-form-group
                  :name="label"
                  :label="$t(label)"
                >
                <!-- v-model="form.payment_due_date" -->
                  <DatePicker
                    ref="datepicker"
                    class="inline-block h-full"
                    :mask="masks"
                    v-model="range"
                    :mode="is_datetime ? 'dateTime': 'date'"
                    :model-config="modelConfig"
                    is-range
                  >
                    <template v-slot="{ inputValue, togglePopover }">
                      <div class="flex items-center justify-content-center align-content-center">
                        <b-input-group class="bg-white">
                          <b-form-input readonly :value="inputValue.start" class="border-right-0 border-primary text-center" />
                          <div class="d-flex align-items-center border-top border-bottom border-primary">
                            <i class="fas fa-arrow-right bg-white"></i>
                          </div>

                          <b-form-input readonly :value="inputValue.end"  class="border-left-0 border-primary text-center rounded-right"/>
                          <b-input-group-append style="margin-left:3px;">
                            <b-button
                            variant="outline-primary"
                              class="rounded-lg"
                              @click="togglePopover"
                            >
                              <i class="far fa-calendar-alt font-17"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </template>
                  </DatePicker>
                </b-form-group>
              </b-col>
            </b-row>
            <div>
              <!-- <form-summary /> -->
            </div>
          <!-- </form-wrapper> -->
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss">
</style>